var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtifactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0951 5.42811H9.99991L8.4761 3.9043H3.90467C3.06657 3.9043 2.38848 4.59001 2.38848 5.42811L2.38086 14.571C2.38086 15.4091 3.06657 16.0948 3.90467 16.0948H16.0951C16.9332 16.0948 17.619 15.4091 17.619 14.571V6.95192C17.619 6.11382 16.9332 5.42811 16.0951 5.42811ZM11.5237 13.0472H5.42848V11.5233H11.5237V13.0472ZM14.5713 9.99953H5.42848V8.47573H14.5713V9.99953Z",
    fill: "#2E87D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2857,
    height: 18.2857,
    fill: "white",
    transform: "translate(0.857056 0.856445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtifactIcon);
export default __webpack_public_path__ + "static/media/artifactIcon.b0ef65f6ad9717d00af6f11c49960c03.svg";
export { ForwardRef as ReactComponent };